import store from "../store";
import axios from "axios";
import router from "@/router";
import APIs from "@/components/APIInit";
import db from "@/components/firebaseInit";
import analytics from "@/components/Analytics";
import routeConfig from "@/assets/route-config";
import { bus } from "@/main";
import common from "@/common";

const landingURLOptions = {
	"/lobby": "Lobby",
	"/sessions": "Sessions",
	"/session_cal": "session_cal",
	"/livestage": "LiveStage",
	"/stageview": "StageView",
	"/attendee": "AttendeeList",
	"/exhibitorshall": "ExhibitorsHall",
	"/mymeetings": "MyMeetings",
	"/myprofile": "MyProfile",
};
var vm;
interface EventSummery {
	ClientId: string,
	EventId: string,
	EventCollectionName: string,
	EventFullName: string,
	Description: string,
	EventLogo: string,
	EventBannerShare: string,
	IsPublished: boolean,
	EventStartDateTimeStamp: number,
	EventEndDateTimeStamp: number,
	TimeZone: string,
	EventTime: string,
	HasAdminRole: boolean,
}

interface UserProfile {
	UserId: string,
	Name: string,
	FirstName: string,
	LastName: string,
	Email: string,
	Company: string,
	Designation: string,
	Phone: string,
	Profile: string,
	ProfileImageURL: string,
}

export default {
	methods: {
		getSessionToken() {
			let val = "";
			val = store.getters.getToken;
			return val;
		},
		getSessionUserId() {
			let val = "";
			val = store.getters.getUserId;
			return val;
		},
		getSessionUser() {
			return store.getters.getUser;
		},
		getSessionUserProfile() {
			var user = store.getters.getUser;
			let obj: UserProfile = {
				UserId: user.id,
				Name: user.name,
				FirstName: user.fname,
				LastName: user.lname,
				Email: user.Email,
				Company: user.company,
				Designation: user.title,
				Phone: user.phone,
				Profile: "",
				ProfileImageURL: user.profilepic,
			};
			return obj;
		},
		isVisitor() {
			var result = false;
			var roles = store.getters.getUserRoles;
			if (store.state.userRole && store.state.userRole.length > 0) {
				for (var i = 0; i < roles.length; i++) {
					var role = roles[i];
					if (role.RoleID == 99) {
						result = true;
						break;
					}
				}
			}
			return result;
		},
		getEventCollectionName() {
			let val = "";
			val = store.getters.getEventCollectionName;
			return val;
		},
		getPublicEventCollection() {
			let val = "";
			val = store.getters.getPublicEventCollection;
			return val;
		},
		getClientId() {
			return store.getters.getClientId;
		},
		getEventId() {
			let val = "";
			val = store.getters.getEvent;
			return val;
		},
		getPublicEventId() {
			let val = "";
			val = store.getters.getPublicEventCollection;
			if (val) {
				var list = val.split("E");
				if (list.length > 1) {
					val = "E" + list[1];
				}
			}
			return val;
		},
		getPublicClientId() {
			let val = "";
			val = store.getters.getPublicEventCollection;
			if (val) {
				val = val.replace("OA_UAT_", "");
				var list = val.split("E");
				if (list.length > 0) {
					val = list[0];
				}
			}
			return val;
		},
		getEventName() {
			let val = "";
			val = store.getters.getEventName;
			return val;
		},
		getEventStartDate() {
			let val = "";
			val = store.getters.getEventSdate;
			return val;
		},
		getEventEndDate() {
			let val = "";
			val = store.getters.getEventEdate;
			return val;
		},
		getCurrentEvent() {
			let val = "";
			val = store.getters.getCurrentEvent;
			if (!val) {
				val = "";
			}
			return val;
		},
		getEventLandingURL() {
			let result = "";
			let val = "";
			val = store.getters.getCurrentEvent;
			if (val) {
				result = val["DefaultLandingURL"];
				if (result) {
					result = result.toLowerCase();
				}
			}
			return result;
		},
		getDesktopBanner(isClientBanner) {
			var branding;
			if (isClientBanner) {
				branding = store.getters.getBranding;
			}
			else {
				branding = store.getters.getEventBranding;
			}
			if (branding && branding.length > 0 && branding[0].banner) {
				return branding[0].banner ? branding[0].banner : "";
			}
			else {
				return "";
			}
		},
		getMobleBanner(isClientBanner) {
			var branding;
			if (isClientBanner) {
				branding = store.getters.getBranding;
			}
			else {
				branding = store.getters.getEventBranding;
			}
			if (branding && branding.length > 0 && branding[0].mobileBanner) {
				return branding[0].mobileBanner ? branding[0].mobileBanner : "";
			}
			else {
				return "";
			}
		},
		getSocialShareBanner(isClientBanner) {
			var branding;
			if (isClientBanner) {
				branding = store.getters.getBranding;
			}
			else {
				branding = store.getters.getEventBranding;
			}
			if (branding && branding.length > 0 && branding[0].shareBanner) {
				return branding[0].shareBanner ? branding[0].shareBanner : "";
			}
			else {
				return "";
			}
		},
		setBannerKey(bannerKey, bannerKeyValue) {
			var branding;
			if (!bannerKeyValue) {
				bannerKeyValue = "";
			}
			if (bannerKey) {
				branding = store.getters.getEventBranding;
				if (branding && branding.length > 0) {
					branding[0][bannerKey] = bannerKeyValue;
				}
			}
		},
		getClientIP() {
			let val = "";
			val = store.getters.getClientIP;
			return val;
		},
		IsSelfServiceEnabled() {
			var result = store.getters.getEnableSelfService;
			if (result != true) {
				result = false;
			}
			return result;
		},
		isClientAdmin() {
			var result = false;
			var roles = store.getters.getUserRoles;
			if (roles && roles.length > 0) {
				for (var i = 0; i < roles.length; i++) {
					var role = roles[i];
					if (role.RoleID == 2) {
						result = true;
						break;
					}
				}
			}
			return result;
		},
		// isClientAdmin() {
		// 	var result = false;
		// 	var roles = store.getters.getAdminRoles;
		// 	var eventId = this.getEventId();
		// 	var clientId = this.getClientId();
		// 	if (roles && roles.length > 0) {
		// 		for (var i = 0; i < roles.length; i++) {
		// 			var role = roles[i];
		// 			if (role.ClientId == clientId && role.EventId == eventId && role.RoleID == 2) {
		// 				result = true;
		// 				break;
		// 			}
		// 		}
		// 	}
		// 	return result;
		// },
		isEventAdmin() {
			var result = false;
			var roles = store.getters.getAdminRoles;
			var eventId = this.getEventId();
			var clientId = this.getClientId();
			//RoleID: 3, EventId: "E1637219036051", RoleName: "EventAdmin", ClientId: "C1591205467009"
			//var paramEventId = this.$route.params.e;
			if (roles && roles.length > 0) {
				for (var i = 0; i < roles.length; i++) {
					var role = roles[i];
					if (role.ClientId == clientId && role.EventId == eventId && role.RoleID == 3) {
						result = true;
						break;
					}
				}
			}
			return result;
		},
		hasEventAdminRole(eventId) {
			var result = false;
			var roles = store.getters.getAdminRoles;
			var clientId = this.getClientId();
			//RoleID: 3, EventId: "E1637219036051", RoleName: "EventAdmin", ClientId: "C1591205467009"
			//var paramEventId = this.$route.params.e;
			if (roles && roles.length > 0) {
				for (var i = 0; i < roles.length; i++) {
					var role = roles[i];
					if (role.ClientId == clientId && (!eventId || role.EventId == eventId) && role.RoleID == 3) {
						result = true;
						break;
					}
				}
			}
			return result;
		},
		GetMappedEvents() {
			var result: EventSummery[] = [];
			var roles = store.getters.getAdminRoles;
			var events = store.getters.getMappedEvent;
			var clientId = this.getClientId();
			for (var i = 0; i < events.length; i++) {
				var event = events[i];
				var hasAdminRole = false;
				if (roles && roles.length > 0) {
					for (var j = 0; j < roles.length; j++) {
						var role = roles[j];
						if (event.ClientId == clientId && event.ClientId == role.ClientId && event.EventId == role.EventId && role.RoleID == 3) {
							hasAdminRole = true;
						}
					}
				}
				let eventBannerShare = event.EventBannerShare ? event.EventBannerShare : event.EventLogo;
				let startTime = "";
				if (event.EventStartDateTimestamp) {
					startTime = common.getFormattedDateTime(event.EventStartDateTimestamp);
				}
				let endTime = "";
				if (event.EventEndtDateTimestamp) {
					endTime = common.getFormattedDateTime(event.EventEndtDateTimestamp);
				}
				let eventTime = "";

				if (startTime.substring(0, 8) == endTime.substring(0, 8)) {
					//startTime = startTime.replace(startTime.substring(0, 8), "");
					endTime = endTime.replace(endTime.substring(0, 8), "");
				}
				eventTime = startTime + " - " + endTime;
				let obj: EventSummery = {
					ClientId: event.ClientId,
					EventId: event.EventId,
					EventFullName: event.EventFullName,
					EventCollectionName: event.EventCollectionName,
					Description: event.Description,
					EventLogo: event.EventLogo,
					EventBannerShare: eventBannerShare,
					IsPublished: event.IsPublished,
					TimeZone: event.TimeZone,
					EventStartDateTimeStamp: event.EventStartDateTimestamp,
					EventEndDateTimeStamp: event.EventEndtDateTimestamp,
					EventTime: eventTime,
					HasAdminRole: hasAdminRole,
				}
				result.push(obj);
			}
			return result;
		},
		GetAdminEvents() {
			var result: EventSummery[] = [];
			var roles = store.getters.getAdminRoles;
			var events = store.getters.getMappedEvent;
			//var eventId = this.getEventId();
			var clientId = this.getClientId();
			//RoleID: 3, EventId: "E1637219036051", RoleName: "EventAdmin", ClientId: "C1591205467009"
			if (roles && roles.length > 0) {
				for (var i = 0; i < events.length; i++) {
					var event = events[i];
					for (var j = 0; j < roles.length; j++) {
						var role = roles[j];
						if (event.ClientId == clientId && event.ClientId == role.ClientId && event.EventId == role.EventId && role.RoleID == 3) {
							//if (role.ClientId == clientId && role.EventId == eventId && role.RoleID == 3) {
							//alert(event.EventBanner)
							let eventBannerShare = event.EventBannerShare ? event.EventBannerShare : event.EventLogo;
							let startTime = "";
							if (event.EventStartDateTimestamp) {
								startTime = common.getFormattedDateTime(event.EventStartDateTimestamp);
							}
							let endTime = "";
							if (event.EventEndtDateTimestamp) {
								endTime = common.getFormattedDateTime(event.EventEndtDateTimestamp);
							}
							let eventTime = "";

							if (startTime.substring(0, 8) == endTime.substring(0, 8)) {
								//startTime = startTime.replace(startTime.substring(0, 8), "");
								endTime = endTime.replace(endTime.substring(0, 8), "");
							}
							eventTime = startTime + " - " + endTime;
							let obj: EventSummery = {
								ClientId: role.ClientId,
								EventId: role.EventId,
								EventFullName: event.EventFullName,
								EventCollectionName: event.EventCollectionName,
								Description: event.Description,
								EventLogo: event.EventLogo,
								EventBannerShare: eventBannerShare,
								IsPublished: event.IsPublished,
								TimeZone: event.TimeZone,
								EventStartDateTimeStamp: event.EventStartDateTimestamp,
								EventEndDateTimeStamp: event.EventEndtDateTimestamp,
								EventTime: eventTime,
								HasAdminRole: true,
							}
							result.push(obj);
							break;
							//}
						}
					}
				}
			}
			//alert(result.length)
			return result;
		},
		ChangeCurrentEvent(clientId, eventId, isEditMode, doNoRedirect) {
			vm = this;
			debugger;

			bus.$emit("toggleLoader", true);
			db.collection("OA_UAT/ClientList/Clients")
				.doc(clientId)
				.collection("Events")
				.doc(eventId)
				.get()
				.then(function (doc) {
					if (doc.exists) {
						var eventData = doc.data();
						vm.GoToCurrentEvent(eventData, isEditMode, doNoRedirect);
					}
				})
				.catch((error) => {
					bus.$emit("toggleLoader", false);
					//vm.hideLoader();
					console.log(error);
				});
		},
		async GoToCurrentEvent(eventData, isEditMode, doNoRedirect) {
			if (eventData && eventData.ClientId && eventData.EventId) {
				store.state.historyEvent = eventData;
				store.state.locale = eventData.DefaultLanguage;
				store.commit("addEventID", eventData.EventId);
				store.commit("setEventDefaultSessionPage", eventData.DefaultSessionPath);
				store.commit("addEventCollection", eventData.EventCollectionName);
				store.commit("addEventName", eventData.EventFullName);
				store.commit("addEventSdate", eventData.EventStartDate);
				store.commit("addEventEdate", eventData.EventEndDate);
				store.commit("addZone", eventData.TimeZone);
				store.commit("Lobbyloaded", false);
				store.commit("setBrandingJsonUrl", eventData.brandingJsonUrl);
				let clientName = store.state.client[0].name;
				store.commit("addClientID", {
					id: eventData.ClientId,
					name: clientName,
				});

				//Font style EventCustomCSS.json JSON
				console.log("eventData===========", eventData);

				var brandingData;
				try {
					brandingData = await vm.getBrandingJSONDetails(eventData.EventCollectionName + "/Branding/CustomStyle/EventCustomCSS.json");
					debugger;
					console.log("brandingData===========", brandingData);

					if (brandingData && brandingData.data && brandingData.data.customClientFont != undefined) {
						store.commit("AddEventFont", {
							FontPath: brandingData.data.customClientFont.FontPath,
							FontFamily: brandingData.data.customClientFont.FontFamily,
						});
					}
				} catch (e) {
					debugger;
					store.commit("AddEventFont", {
						FontPath: "",
						FontFamily: "",
					});
					bus.$emit("toggleLoader", false);
					console.log("Error in Branding Json Fetch--", e);
				}

				try {
					debugger;
					brandingData = await vm.getBrandingJSONDetails(
						eventData.EventCollectionName + "/Branding/Branding.json"
					);
					if (brandingData.data != undefined) {
						//this.item = brandingData.data;
						var bannerDymension = "2048x88";
						var EventBgDymension = "2732x2048";
						var logoDymension = "960x192";
						store.commit("addEventBranding", {
							eventBGImage: vm.getCDNUrl(
								brandingData.data.eventBGImage[EventBgDymension]
							),
							eventLogo: vm.getCDNUrl(brandingData.data.eventLogo[logoDymension]),
							topBar: brandingData.data.webheaderColorsHexCode ? brandingData.data.webheaderColorsHexCode["topBar"] : brandingData.data.headerColorsHexCode["topBar"],
							headerBar: brandingData.data.webheaderColorsHexCode ? brandingData.data.webheaderColorsHexCode["headerBar"] : brandingData.data.headerColorsHexCode["headerBar"],
							fontBar: brandingData.data.webheaderColorsHexCode ? brandingData.data.webheaderColorsHexCode["fontBar"] : brandingData.data.headerColorsHexCode["fontBar"],
							sideNavigationAndIconColor:
								brandingData.data.webheaderColorsHexCode ? brandingData.data.webheaderColorsHexCode["sideNavigationAndIconColor"] : brandingData.data.headerColorsHexCode["sideNavigationAndIconColor"],
							banner: vm.getCDNUrl(brandingData.data.banner[bannerDymension]),
							mobileBanner: vm.getCDNUrl(brandingData.data.banner["750x103"]),
							shareBanner: vm.getCDNUrl(
								brandingData.data.EventInfo.EventBannerShare)
								? brandingData.data.EventInfo.EventBannerShare
								: "",
							themeName: brandingData.data["appColorHexCodeType"],


						});
						// if (obj !== undefined) {
						// 	if (obj !== null) {
						// 		if (obj.EventBranding[0] !== undefined) {
						// 			$("#imgBanner").attr(
						// 				"src",
						// 				vm.getCDNUrl(obj.EventBranding[0].banner)
						// 			);
						// 		}
						// 	}
						// }
						//$("#btnLoadMenu").click();
						debugger;
						bus.$emit("LoadEventDetails");
						this.getMeetingSettings1(eventData.ClientId, eventData.EventId);
						this.getAdvExpoStatus1(eventData.EventCollectionName);
						this.getDynamicFont1();
						let landingURL = "Lobby";
						if (
							eventData.DefaultLandingURL &&
							landingURLOptions[eventData.DefaultLandingURL] &&
							landingURLOptions[eventData.DefaultLandingURL] != ""
						) {
							landingURL = landingURLOptions[eventData.DefaultLandingURL];
							store.commit("setDefaultLandingPageInsideEvent", landingURL);
						}

						if (landingURL === "ExhibitorsHall") {
							vm.onExpoSelection();
							store.commit("setAdvExpo", true);
						}

						if (
							store.state.eventDefaultSessionPage &&
							landingURL != "Lobby"
						) {
							landingURL =
								landingURLOptions[store.state.eventDefaultSessionPage];
						}
						if (isEditMode) {

							setTimeout(() => {

								if (vm.$route.name == "Events") {
									bus.$emit("toggleLoader", false);
									router.push("/eventv3/" + eventData.EventId);
								}
								else if (vm.$route.name == "AdminOverview" || vm.$route.name == "BasicInfo") {
									bus.$emit("toggleSelfServiceEventCreateLoader", false);
									router.push("/eventsetup");
									// landingURL = vm.getAdminEditUrl(landingURL);
									// router.push({
									// 	name: landingURL,
									// 	params: {
									// 		sid: eventData.EventId,
									// 		eCol: eventData.EventCollectionName,
									// 		ename: eventData.EventFullName,
									// 		estartdt: eventData.EventStartDate,
									// 		eenddt: eventData.EventEndDate,
									// 		tzone: eventData.Timezone,
									// 	},
									// });
								}
								else {
									bus.$emit("toggleLoader", false);
									location.reload();
								}
							}, 1000);
							// router.push({
							// 	name: landingURL,
							// 	params: {
							// 		sid: eventData.EventId,
							// 		eCol: eventData.EventCollectionName,
							// 		ename: eventData.EventFullName,
							// 		estartdt: eventData.EventStartDate,
							// 		eenddt: eventData.EventEndDate,
							// 		tzone: eventData.Timezone,
							// 	},
							// });
						} else if (!doNoRedirect) {
							bus.$emit("toggleLoader", false);
							var loginType = store.state.loginType;
							var user = vm.getSessionUser();
							//var clientIP = store.state.ClientIP;
							analytics.AddUserLogin(
								eventData.EventCollectionName,
								eventData.EventFullName,
								location.pathname,
								"click",
								"action",
								loginType,
								user.id,
								user.fname.trim() + " " + user.lname.trim(),
								user.Email
							);
							vm.postLeaderboardAction("EVAC");
							router.push({
								name: landingURL,
								params: {
									sid: eventData.EventId,
									eCol: eventData.EventCollectionName,
									ename: eventData.EventFullName,
									estartdt: eventData.EventStartDate,
									eenddt: eventData.EventEndDate,
									tzone: eventData.Timezone,
								},
							});
						}
					}
				} catch (e) {
					bus.$emit("toggleLoader", false);
					console.log("Error in Branding Json Fetch--", e);
				}
			}
		},
		getMeetingSettings1: function (clientId, eventId) {
			//const obj = JSON.parse(window.localStorage["my-app"]);
			let headers = {
				Authorization: "Bearer " + this.getSessionToken(),
				"content-type": "application/json",
			};
			let requestData = {
				key: {
					instanceId: "OA_UAT",
					clientId: clientId,
					eventId: eventId,
				},
			};
			axios
				.post(APIs.MeetingAPIConfig.GetConfig, JSON.stringify(requestData), {
					headers: headers,
				})
				.then((response) => {
					if (response.data) {
						var res = response.data;
						var MObj;
						MObj.Slot = res.data.Slots;
						MObj.StartDate1 = res.data.StartDate;
						MObj.EndDate1 = res.data.EndDate;
						//MObj.StartDate = moment(res.data.MeetingStartTimestampUTC / 1000);
						//MObj.EndDate = new Date(res.data.MeetingEndTimestampUTC / 1000);
						MObj.StartDate = {
							_seconds: res.data.MeetingStartTimestampUTC / 1000,
							_nanoseconds: 0,
						};
						MObj.EndDate = {
							_seconds: res.data.MeetingEndTimestampUTC / 1000,
							_nanoseconds: 0,
						};
						MObj.AvailabilityFromTime = res.data.AvailabilityFromTime;
						MObj.AvailabilityToTime = res.data.AvailabilityToTime;
						MObj.ButtonLabel = res.data.ButtonLabel;
						MObj.Duration = res.data.Duration;
						if (res.data.ByTimezone !== undefined) {
							MObj.ByTimezone = res.data.ByTimezone;
						} else {
							MObj.ByTimezone = false;
						}
						if (res.data.Items && res.data.Items.length > 0) {
							MObj.Items = res.data.Items;
						}
						store.commit("addMeetingSettings", MObj);
					}
				})
				.catch((error) => {
					bus.$emit("toggleLoader", false);
					console.log(error);
				});
		},
		getAdvExpoStatus1: function (eventcollectionname) {
			db.collection(eventcollectionname)
				.doc("Settings")
				.collection("Exhibitor")
				.get()
				.then((querySnapshot) => {
					querySnapshot.forEach((doc) => {
						if (doc.data().EnableEnhancedExpoMode === true) {
							store.commit("setAdvExpo", true);
						} else {
							store.commit("setAdvExpo", false);
						}
					});
				})
				.catch((error) => {
					bus.$emit("toggleLoader", false);
					console.log(error);
				});
		},
		getDynamicFont1: function () {
			var obj = store.state;
			let newStyle = document.querySelector("#dynamicFont");
			if (!newStyle) {
				newStyle = document.createElement("style");
				newStyle.setAttribute("id", "dynamicFont");
			}
			if (obj.EventFont != undefined) {
				if (obj.EventFont.length > 0) {
					var urlpath = "";
					if (obj.EventFont[0].FontPath != "") {
						if (obj.EventFont[0].FontFamily != "") {
							urlpath = obj.EventFont[0].FontPath;
							newStyle.appendChild(document.createTextNode("@font-face {font-family: " + obj.EventFont[0].FontFamily + "; src:" + urlpath + ";}"));
							newStyle.appendChild(document.createTextNode("* { font-family: '" + obj.EventFont[0].FontFamily + "' !important }"));
						}
					}
				}
			}
			if (newStyle.children.length == 0) {
				newStyle.appendChild(document.createTextNode("* { font-family: 'Roboto' !important }"));
			}
			document.head.appendChild(newStyle);
		},
		getAdminEditUrl(routeName) {
			for (var i = 0; i < routeConfig.PreviewEditMap.length; i++) {
				if (routeConfig.PreviewEditMap[i].RouteName == routeName) {
					routeName = routeConfig.PreviewEditMap[i].AdminRouteName;
					break;
				}
			}
			return routeName;
		},
		hasValidAuth(page_params) {
			//var eventId = this.getEventId();
			var user = this.getSessionUserProfile();
			var needLogin = false;
			var needVisitorLogin = false;
			//var needEventSwitch = false;
			//user.UserId && user.Email != "visitor@e2m.live"
			if (!user.UserId) {
				needLogin = true;
				if (page_params && page_params.auth_type == 0) {
					needVisitorLogin = true;
				}
			} else {
				if (page_params) {
					if (page_params.auth_type == 1 && user.Email == "visitor@e2m.live") {
						needLogin = true;
					}
				}
			}
			// if (!eventId) {
			// 	if (page_params) {
			// 		if (page_params.auth_type == 0) {
			// 			needVisitorLogin = true;
			// 		} else if (page_params.auth_type == 1 && user) {
			// 			needLogin = true;
			// 		}
			// 	}
			// } else if (page_params) {
			// 	if (page_params.eventId && page_params.eventId != eventId) {
			// 		needLogin = true;
			// 	} else if (page_params.eventId && page_params.eventId != eventId) {
			// 		needEventSwitch = true;
			// 	}
			// }
			if ((needLogin || needVisitorLogin)) {
				if (!page_params.no_need_reg_login) {
					bus.$emit("openLoginRegDecision", page_params);
				}
				return false;
			} else {
				return true;
			}
		},
		closeLoginRegDecision() {
			bus.$emit("closeLoginRegDecision");
		},
	}
}